var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React from 'react';
var ReconnectSocket = (function (_super) {
    __extends(ReconnectSocket, _super);
    function ReconnectSocket(props) {
        var _this = _super.call(this, props) || this;
        _this.handleReconnect = _this.handleReconnect.bind(_this);
        return _this;
    }
    ReconnectSocket.prototype.handleReconnect = function () {
        window.socket.open();
    };
    ReconnectSocket.prototype.render = function () {
        return (React.createElement("a", { onClick: this.handleReconnect }, this.props.displayText || 'Reconnect'));
    };
    return ReconnectSocket;
}(React.Component));
export default ReconnectSocket;



//////////////////
// WEBPACK FOOTER
// ./src/pages/components/utilities/ReconnectSocket.tsx
// module id = 651
// module chunks = 0